import React, { createContext, useContext, useState, useEffect } from "react";
import { translations } from "../translations/translations";

const LanguageContext = createContext();

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(() => {
    const saved = localStorage.getItem("realtime_lang");
    if (saved && ["am", "ru", "en"].includes(saved)) {
      return saved;
    }
    return "am"; // Default is Armenian per requirements
  });

  const setLanguage = (lang) => {
    if (["am", "ru", "en"].includes(lang)) {
      setLanguageState(lang);
      localStorage.setItem("realtime_lang", lang);
    }
  };

  useEffect(() => {
    // Update HTML lang attribute
    document.documentElement.lang = language === "am" ? "hy" : language;
  }, [language]);

  // Translation helper with fallback to Armenian
  const t = (path) => {
    const keys = path.split(".");
    let current = translations[language];
    for (const key of keys) {
      if (current && current[key] !== undefined) {
        current = current[key];
      } else {
        // Fallback to Armenian
        let fallback = translations["am"];
        for (const fKey of keys) {
          if (fallback && fallback[fKey] !== undefined) {
            fallback = fallback[fKey];
          } else {
            return path;
          }
        }
        return fallback;
      }
    }
    return current;
  };

  return (
    <LanguageContext.Provider value={{ language, setLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error("useLanguage must be used within a LanguageProvider");
  }
  return context;
}
